import Stage from './stage'

export default Stage
